import img01 from "@/assets/gallery/01-miller-story-brand.jpg";
import img02 from "@/assets/gallery/02-koe-art-of-focus.jpg";
import img03 from "@/assets/gallery/03-uzdavinys-theurgy-sunset.jpg";
import img04 from "@/assets/gallery/04-hale-sin-and-syntax.jpg";
import img05 from "@/assets/gallery/05-flynn-superfans.jpg";
import img06 from "@/assets/gallery/06-aethyrius-alchemy-unveiled.jpg";
import img07 from "@/assets/gallery/07-heath-made-to-stick.jpg";
import img08 from "@/assets/gallery/08-sinek-start-with-why.jpg";
import img09 from "@/assets/gallery/09-uzdavinys-theurgy-sunset-alt.jpg";

import img11 from "@/assets/gallery/11-michalowicz-profit-first.jpg";
import img12 from "@/assets/gallery/12-gunderson-killing-sacred-cows.jpg";
import img13 from "@/assets/gallery/13-kaldellis-hellenism-byzantium.jpg";

import avif01 from "@/assets/gallery/01-miller-story-brand.avif";
import avif02 from "@/assets/gallery/02-koe-art-of-focus.avif";
import avif03 from "@/assets/gallery/03-uzdavinys-theurgy-sunset.avif";
import avif04 from "@/assets/gallery/04-hale-sin-and-syntax.avif";
import avif05 from "@/assets/gallery/05-flynn-superfans.avif";
import avif06 from "@/assets/gallery/06-aethyrius-alchemy-unveiled.avif";
import avif07 from "@/assets/gallery/07-heath-made-to-stick.avif";
import avif08 from "@/assets/gallery/08-sinek-start-with-why.avif";
import avif09 from "@/assets/gallery/09-uzdavinys-theurgy-sunset-alt.avif";

import avif11 from "@/assets/gallery/11-michalowicz-profit-first.avif";
import avif12 from "@/assets/gallery/12-gunderson-killing-sacred-cows.avif";
import avif13 from "@/assets/gallery/13-kaldellis-hellenism-byzantium.avif";

export type GalleryTone = "light" | "dark" | "gradient";

export interface GalleryItem {
  src: string;
  avif?: string;
  author: string;
  work: string;
  tone: GalleryTone;
}

export const gallery: GalleryItem[] = [
  { src: img01, avif: avif01, author: "Donald Miller", work: "Building a StoryBrand", tone: "light" },
  { src: img02, avif: avif02, author: "Dan Koe", work: "The Art of Focus", tone: "dark" },
  { src: img03, avif: avif03, author: "Algis Uždavinys", work: "Philosophy & Theurgy in Late Antiquity", tone: "gradient" },
  { src: img04, avif: avif04, author: "Constance Hale", work: "Sin and Syntax", tone: "light" },
  { src: img05, avif: avif05, author: "Pat Flynn", work: "Superfans", tone: "dark" },
  { src: img06, avif: avif06, author: "Aethyrius", work: "Alchemy Unveiled", tone: "gradient" },
  { src: img07, avif: avif07, author: "Chip & Dan Heath", work: "Made to Stick", tone: "light" },
  { src: img08, avif: avif08, author: "Simon Sinek", work: "Start With Why", tone: "dark" },
  { src: img09, avif: avif09, author: "Algis Uždavinys", work: "Philosophy & Theurgy in Late Antiquity", tone: "gradient" },
  
  { src: img11, avif: avif11, author: "Mike Michalowicz", work: "Profit First", tone: "dark" },
  { src: img12, avif: avif12, author: "Garrett B. Gunderson", work: "Killing Sacred Cows", tone: "light" },
  { src: img13, avif: avif13, author: "Anthony Kaldellis", work: "Hellenism in Byzantium", tone: "light" },
];
